import ModalWindowLayout from './ModalWindowLayout'

export default ModalWindowLayout
